function initContinueReadingSplides() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-continue-reading-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var count = el.querySelectorAll('.continue-reading__item').length;
    var perPageDesktop = Math.min(count, 3);

    /* Mobile shows one card plus a peek of the next one, same fixedWidth trick
       used by featured-products-row.js (perPage must stay an integer for
       Splide's index math, so the peek comes from fixedWidth instead). */
    var mobileGap = '10px';
    var mobilePerView = 1;
    var mobileSlideWidth = 'calc((100% + ' + mobileGap + ')/' + mobilePerView + ' - ' + mobileGap + ')';

    var slider = new Splide(el, {
      type: 'slide',
      perPage: perPageDesktop,
      perMove: 1,
      gap: '16px',
      pagination: false,
      arrows: false,
      drag: false,
      breakpoints: {
        991: {
          perPage: 1,
          perMove: 1,
          gap: mobileGap,
          fixedWidth: mobileSlideWidth,
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var prevBtn = el.querySelector('.continue-reading__arrows .continue-reading__arrow-btn--prev');
    var nextBtn = el.querySelector('.continue-reading__arrows .continue-reading__arrow-btn--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.go('<');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.go('>');
      });
    }

    var bar = el.querySelector('.js-continue-reading-progress-bar');

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;

      var index = Math.min(Math.max(slider.index, 0), end);

      if (bar) {
        var rate = Math.min((index + 1) / (end + 1), 1);
        bar.style.width = String(100 * rate) + '%';
      }
      if (prevBtn) {
        prevBtn.disabled = index <= 0;
      }
      if (nextBtn) {
        nextBtn.disabled = index >= end;
      }
    }

    slider.on('mounted move moved updated refresh resized scrolled', syncControls);

    slider.mount();
  });
}

document.addEventListener('DOMContentLoaded', initContinueReadingSplides);
window.addEventListener('load', initContinueReadingSplides);

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.js-continue-reading-splide') || node.querySelector('.js-continue-reading-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initContinueReadingSplides();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
